import React, { useContext } from "react";
import commonContext from "../../../context/common";
import { infoIcon } from "../../../utils/images";

function ReviewViewDetailedBreakDown() {
    const { lead, utils, base } = useContext(commonContext);
    return (
        <>
            <div className="container my-5 mx-auto sm:px-2 md:px-5">
                <h2 className="openSans-Reg text-black my-3 text-3xl md:text-3xl lg:text-3xl xl:text-4xl">
                    View Detailed Breakdown
                </h2>
                <div className="w-full flex flex-wrap">
                    {base == "zd-10-seconds" || base == "dd-al" ? (
                        <>
                            <div className="relative w-full md:w-1/2 lg:w-1/2 xl:w-1/2 py-2 pr-0 md:pr-2">
                                <div className="w-full rounded-lg lighter-blue-2 px-6 py-6">
                                    <h3 className="w-full md:w-10/12 openSans-Reg text-black text-2xl md:text-3xl lg:text-4xl mb-5">
                                        Vehicle Price
                                    </h3>
                                    <div className="w-full">
                                        <div className="w-full flex flex-wrap items-center mb-3">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                Ex-showroom Price
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>
                                                {utils.currencyFormat(
                                                    lead.avgCost
                                                )}
                                            </p>
                                        </div>
                                        <div className="w-full flex flex-wrap items-center mb-3">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                Discount Received
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>
                                                {utils.currencyFormat(
                                                    lead.discountPrice
                                                )}
                                            </p>
                                        </div>
                                        <div className="w-full border-t lightborder py-3">
                                            <div className="w-full flex flex-wrap items-center">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-black">
                                                    Final Car Price
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-2xl md:text-2xl lg:text-3xl relative pl-4">
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    {utils.currencyFormat(
                                                        lead.avgCost -
                                                            lead.discountPrice
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                    {lead.motorInsuranceAvailed ||
                    lead.roadTaxInsuranceAvailed ? (
                        <div className="relative w-full md:w-1/2 lg:w-1/2 xl:w-1/2 py-2 pl-0 md:pl-2">
                            <div className="w-full rounded-lg lighter-blue-2 px-6 py-6">
                                <h3 className="w-full md:w-10/12 openSans-Reg text-black text-2xl md:text-3xl lg:text-4xl mb-5">
                                    Extra Charges
                                </h3>
                                <div className="w-full">
                                    {base == "qm-10-seconds" ? (
                                        <>
                                            {lead.insuranceAvailed ? (
                                                <div className="w-full flex flex-wrap items-center mb-3">
                                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                        Sarv Surksha Premium
                                                    </p>
                                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        {utils.currencyFormat(
                                                            lead.insuranceSsiPremium
                                                        )}
                                                    </p>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </>
                                    ) : (
                                        <>
                                            {lead.roadTaxInsuranceAvailed ? (
                                                <div className="w-full flex flex-wrap items-center mb-3">
                                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                        RTO Charges
                                                    </p>
                                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                        <span className="WebRupee">
                                                            Rs.
                                                        </span>
                                                        {utils.currencyFormat(
                                                            lead.rtoEditAmount
                                                        )}
                                                    </p>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                        </>
                                    )}

                                    {lead.motorInsuranceAvailed ? (
                                        <div className="w-full flex flex-wrap items-center mb-3">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-gray-500">
                                                {base == "qm-10-seconds"
                                                    ? "HDFC Motor Insurance"
                                                    : "HDFC ERGO Insurance"}
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>
                                                {utils.currencyFormat(
                                                    lead.motorInsurancePremium
                                                )}
                                            </p>
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <div className="w-full border-t lightborder py-3">
                                        <div className="w-full flex flex-wrap items-center">
                                            <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-black">
                                                Extra Charges
                                            </p>
                                            <p className="w-1/2 text-right openSans-SemiBold text-black text-2xl md:text-2xl lg:text-3xl relative pl-4">
                                                <span className="WebRupee">
                                                    Rs.
                                                </span>
                                                {utils.currencyFormat(
                                                    (lead.motorInsuranceAvailed
                                                        ? parseFloat(
                                                              lead.motorInsurancePremium
                                                          )
                                                        : 0) +
                                                        (lead.roadTaxInsuranceAvailed
                                                            ? parseFloat(
                                                                  lead.rtoEditAmount
                                                              )
                                                            : 0) +
                                                        (base ==
                                                            "qm-10-seconds" &&
                                                        lead.insuranceAvailed
                                                            ? lead.insuranceSsiPremium
                                                            : 0)
                                                )}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                    {base == "zd-10-seconds" || base == "dd-al" ? (
                        <>
                            <div className="relative w-full md:w-1/2 lg:w-1/2 xl:w-1/2 py-2 pr-0 md:pr-2">
                                <div className="w-full rounded-lg lighter-blue-2 px-6 py-6">
                                    <h3 className="w-full md:w-10/12 openSans-Reg text-black text-2xl md:text-3xl lg:text-4xl mb-5">
                                        Your Contribution to Dealer
                                    </h3>
                                    <div className="w-full">
                                        <div className="w-full border-t lightborder py-3">
                                            <div className="w-full flex flex-wrap items-center">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-black">
                                                    Margin Money
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-2xl md:text-2xl lg:text-3xl relative pl-4">
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    {utils.currencyFormat(
                                                        lead.marginMoneyPaid
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (
                        ""
                    )}
                    <div className="relative w-full md:w-1/2 lg:w-1/2 xl:w-1/2 py-2 pl-0 md:pl-2">
                        <div className="w-full rounded-lg lighter-blue-2 px-6 py-6">
                            <h3 className="w-full md:w-10/12 openSans-Reg text-black text-2xl md:text-3xl lg:text-4xl mb-5">
                                Total Disbursement Amount
                            </h3>
                            <div className="w-full">
                                <div className="w-full flex flex-wrap items-center mb-3">
                                    <div className="w-full flex flex-wrap items-center mb-3">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            Desired Amount
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    lead.desiredLoanAmount
                                                )}
                                            </span>{" "}
                                        </p>
                                    </div>
                                    {lead.roadTaxInsuranceAvailed ? (
                                        <>
                                            <div className="w-full flex flex-wrap items-center mb-3">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                    Road Tax
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                    +{" "}
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>
                                                        {utils.currencyFormat(
                                                            parseFloat(
                                                                lead.rtoEditAmount
                                                            )
                                                        )}
                                                    </span>{" "}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                    {lead.motorInsuranceAvailed ? (
                                        <>
                                            <div className="w-full flex flex-wrap items-center mb-3">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                    {base == "qm-10-seconds"
                                                        ? "HDFC Motor Insurance"
                                                        : "HDFC ERGO Insurance"}
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                    +{" "}
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>
                                                        {utils.currencyFormat(
                                                            parseFloat(
                                                                lead.motorInsurancePremium
                                                            )
                                                        )}
                                                    </span>{" "}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                    {lead.dealerInsuranceAvailed ? (
                                        <>
                                            <div className="w-full flex flex-wrap items-center mb-3">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                    Dealer Insurance
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                    +{" "}
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>
                                                        {utils.currencyFormat(
                                                            parseFloat(
                                                                lead.dealerInsuranceAmtEdit
                                                            )
                                                        )}
                                                    </span>{" "}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                    {lead.insuranceAvailed ? (
                                        <>
                                            <div className="w-full flex flex-wrap items-center mb-3">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                    Sarv Surksha Premium
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                    +{" "}
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>
                                                        {utils.currencyFormat(
                                                            parseFloat(
                                                                lead.insuranceSsiPremium
                                                            )
                                                        )}
                                                    </span>{" "}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                    <div className="w-full flex flex-wrap items-center mb-3">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                            <b>Total Loan Amount</b>
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    lead.totalLoanAmount
                                                )}
                                            </span>{" "}
                                        </p>
                                    </div>
                                    {lead.motorInsuranceAvailed ? (
                                        <>
                                            {" "}
                                            <div className="w-full flex flex-wrap items-center mb-3">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                    {base == "qm-10-seconds"
                                                        ? "HDFC Motor Insurance"
                                                        : "HDFC ERGO Insurance"}
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                    -{" "}
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>
                                                        {utils.currencyFormat(
                                                            parseFloat(
                                                                lead.motorInsurancePremium
                                                            )
                                                        )}
                                                    </span>{" "}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        ""
                                    )}

                                    {lead.insuranceAvailed ? (
                                        <>
                                            <div className="w-full flex flex-wrap items-center mb-3">
                                                <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                                    Sarv Surksha Premium
                                                </p>
                                                <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                                    -{" "}
                                                    <span className="WebRupee">
                                                        Rs.
                                                    </span>
                                                    <span>
                                                        {utils.currencyFormat(
                                                            parseFloat(
                                                                lead.insuranceSsiPremium
                                                            )
                                                        )}
                                                    </span>{" "}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        ""
                                    )}
                                </div>
                                <p className="openSans-SemiBold text-sm md:text-lg xl:text-xl text-black mb-3">
                                    Bank Charges
                                </p>
                                <div className="w-full flex flex-wrap items-center mb-2">
                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                        Stamp Duty
                                    </p>
                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                        - <span className="WebRupee">Rs.</span>
                                        <span>
                                            {utils.currencyFormat(
                                                lead.stampDuty
                                            )}
                                        </span>{" "}
                                    </p>
                                </div>
                                <div className="w-full flex flex-wrap items-center mb-2">
                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                        Collateral Charges
                                    </p>
                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                        - <span className="WebRupee">Rs.</span>
                                        <span>
                                            {lead.collateralCharges}
                                        </span>{" "}
                                    </p>
                                </div>
                                <div className="w-full flex flex-wrap items-center mb-3">
                                    <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-track">
                                        Bank Processing Fees
                                    </p>
                                    <p className="w-1/2 text-right openSans-SemiBold text-black text-lg md:text-2xl xl:text-2xl  relative pl-4">
                                        - <span className="WebRupee">Rs.</span>
                                        <span>
                                            {utils.currencyFormat(
                                                lead.processingFees
                                            )}
                                        </span>
                                    </p>
                                </div>
                                <div className="w-full border-t lightborder py-3">
                                    <div className="w-full flex flex-wrap items-center">
                                        <p className="w-1/2 text-left openSans-Reg text-sm md:text-lg xl:text-xl text-black">
                                            Total Amount
                                        </p>
                                        <p className="w-1/2 text-right openSans-SemiBold text-black text-2xl md:text-2xl lg:text-3xl relative pl-4">
                                            <span className="WebRupee">
                                                Rs.
                                            </span>
                                            <span>
                                                {utils.currencyFormat(
                                                    lead.totalAmount
                                                )}
                                            </span>
                                        </p>
                                    </div>
                                </div>{" "}
                            </div>
                        </div>
                        <div className="w-full my-3">
                            <div className="text-left openSans-Reg text-sm md:text-lg xl:text-xl text-black flex items-center justify-center md:justify-start">
                                <img
                                    src={infoIcon}
                                    className="inline-block pr-2"
                                    alt="Information icon"
                                    title="Information icon"
                                />
                                Your first EMI will be due on{" "}
                                {utils.getDateInFormat(lead.emiStartDate, {
                                    month: "short",
                                    year: "numeric",
                                    day: "numeric",
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ReviewViewDetailedBreakDown;
